import { SaveOutlined } from "@ant-design/icons";
import { Button, message, Select, Tooltip } from "antd";
import { object } from "prop-types";
import React, { useEffect, useState } from "react";
import { useQueryClient } from "react-query";
import { useUpdateCampaignStep } from "../../api/campaignSteps";
import { USERS_PATH } from "../../api/users";

// Captions are lowercased before matching, so tags must be lowercase to ever match.
const normalizeTags = tags => [
  ...new Set(tags.map(tag => tag.trim().toLowerCase()).filter(Boolean)),
];

function OnboardRegexInput({ campaignStep }) {
  const savedRegex = campaignStep.metadata?.regex || [];
  const [tags, setTags] = useState(savedRegex);
  const queryClient = useQueryClient();
  const updateCampaignStep = useUpdateCampaignStep();

  const savedRegexKey = savedRegex.join("\n");
  useEffect(() => {
    setTags(savedRegex);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [savedRegexKey]);

  const isDirty = tags.join("\n") !== savedRegexKey;

  const onSave = () => {
    if (tags.length === 0) {
      message.error("At least one regex tag is required");
      return;
    }

    updateCampaignStep.mutate(
      {
        campaignStepId: campaignStep.campaignStepId,
        body: { metadata: { regex: tags } },
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(USERS_PATH);
          message.success(`Updated regex for step "${campaignStep.name}"`);
        },
        onError: err => {
          message.error(err?.message || "An error occurred");
        },
      }
    );
  };

  return (
    <Tooltip
      title={`Updates campaign step "${campaignStep.name}", which applies to every campaign using it`}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <Select
          mode="tags"
          size="small"
          style={{ minWidth: "200px" }}
          value={tags}
          onChange={values => setTags(normalizeTags(values))}
          tokenSeparators={[","]}
          placeholder="Add regex tags"
          notFoundContent={null}
        />
        <Button
          size="small"
          type={isDirty ? "primary" : "default"}
          icon={<SaveOutlined />}
          disabled={!isDirty}
          loading={updateCampaignStep.isLoading}
          onClick={onSave}
        />
      </div>
    </Tooltip>
  );
}

OnboardRegexInput.propTypes = {
  campaignStep: object,
};

export default OnboardRegexInput;
